import { Injectable } from '@angular/core';
import { StripeElementsService } from './stripe-elements.service';
import {
  ConfirmResult,
  ConfirmPaymentOk,
  ConfirmSetupOk,
} from '../types/payment-element/models';

@Injectable({ providedIn: 'root' })
export class StripeElementsDomAdapterService {
  constructor(private inner: StripeElementsService) { }

  async mountBySelector(
    containerSelector: string,
    clientSecret: string
  ): Promise<void> {
    const container = document.querySelector<HTMLElement>(containerSelector);
    if (!container) throw new Error(`Container ${containerSelector} not found`);
    const el = await this.inner.mountPaymentElement(container, clientSecret);
    if (!el) throw new Error('Stripe mount returned null');
  }

  unmount(): void {
    this.inner.reset();
  }

  async confirmPayment(): Promise<ConfirmResult> {
    const res: any = await this.inner.confirmPayment();
    if (res?.error)
      return {
        ok: false,
        error: res.error,
        message: res.error.message ?? 'Payment confirmation failed',
      };
    const pi = res?.paymentIntent;
    if (!pi?.id) return { ok: false, error: 'Payment confirmation failed', message: 'No paymentIntent returned' };

    const ok: ConfirmPaymentOk = {
      ok: true,
      type: 'payment',
      intentId: pi.id,
      status: pi.status,
      paymentMethodId:
        typeof pi.payment_method === 'string' ? pi.payment_method : undefined,
      amount: typeof pi.amount === 'number' ? pi.amount : undefined,
      currency: typeof pi.currency === 'string' ? pi.currency : undefined,
    };
    return ok;
  }

  async confirmSetup(): Promise<ConfirmResult> {
    const res: any = await this.inner.confirmSetup();
    if (res?.error)
      return {
        ok: false,
        error: res.error,
        message: res.error.message ?? 'Setup confirmation failed',
      };
    const si = res?.setupIntent;
    if (!si?.id) return { ok: false, error: 'Setup confirmation failed', message: 'No setupIntent returned' };

    const ok: ConfirmSetupOk = {
      ok: true,
      type: 'setup',
      intentId: si.id,
      status: si.status,
      paymentMethodId:
        typeof si.payment_method === 'string' ? si.payment_method : undefined,
    };
    return ok;
  }
}
